module.exports = __webpack_public_path__ + "img/hero-illustrate.5f156fb1.png";